<template>
  <div class="block absolute md:hidden bg-white z-40 w-full h-full p-4">
    <div class="flex justify-between items-center">
      <router-link to="/" class="text-xl text-indigo-500"> ATM </router-link>
      <XIcon class="w-6 h-6 text-gray-400 cursor-pointer" @click="$emit('close', true)" />
    </div>
    <div class="mt-10 flex flex-col gap-4 pb-5">
      <CompanySelect />
    </div>
    <div class="border-t border-gray-200 pb-5 pt-5">
      <SideBarMobile />
    </div>
    <div class="border-t border-gray-200">
      <div class="mt-3 max-w-3xl mx-auto space-y-1">
        <div class="px-2">
          <Avatar :size="35" backgroundColor="blue" :username="username" color="white" />
        </div>
        <router-link
          to="/profile"
          class="block p-2 text-sm text-gray-700 rounded-md"
          exact
          exact-active-class="bg-gray-100 text-gray-800"
        >
          <span>{{ $t('label.yourProfile') }}</span>
        </router-link>

        <router-link
          to="/change-password"
          class="block p-2 text-sm text-gray-700"
          exact
          exact-active-class="bg-gray-100 text-gray-800 rounded-md"
        >
          <span>{{ $t('label.changePassword') }}</span>
        </router-link>

        <a class="block p-2 text-sm text-gray-700 cursor-pointer" @click="logout">
          {{ $t('button.logout') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { XIcon } from '@heroicons/vue/outline'
import CompanySelect from './CompanySelect.vue'
import SideBarMobile from '../Sidebar/mobile.vue'

export default defineComponent({
  name: 'Header',
  components: {
    XIcon,
    CompanySelect,
    SideBarMobile,
  },
  setup() {
    const store = useStore()
    const mobileMenuOpen = ref(false)

    const user = computed(() => store.getters['user/user'])
    const username = computed(() => `${user.value?.firstName} ${user.value?.lastName}`)

    const logout = () => {
      store.dispatch('auth/actLogout')
    }

    return {
      logout,
      username,
      mobileMenuOpen,
    }
  },
})
</script>
